import { render, staticRenderFns } from "./inventoryTable.vue?vue&type=template&id=4b0789cb&scoped=true&"
import script from "./inventoryTable.vue?vue&type=script&lang=js&"
export * from "./inventoryTable.vue?vue&type=script&lang=js&"
import style0 from "./inventoryTable.vue?vue&type=style&index=0&id=4b0789cb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0789cb",
  null
  
)

export default component.exports